/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import DaiyoZyomuinUriageService from "../../../service/billing/DaiyoZyomuinUriage/daiyoZyomuinUriageService"
import {
  TDaiyoZyomuinUriageListGetRes,
  TDaiyoZyomuinUriageListGetReq,
  TDaiyoZyomuinUriagePutReq,
} from "../../../service/billing/DaiyoZyomuinUriage/TDaiyoZyomuinUriage"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { showInfoToast } from "../../../components/CustomToast"
import Decimal from "decimal.js"
import { TApiResponse } from "../../../service/TApiResponse"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import TextInput from "../../../components/InputWrapper/TextInput"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import stringUtil from "../../../ts/util/stringUtil"
import dateUtil from "../../../ts/util/dateUtil"

//#region [type]
export type T大陽乗務員売上リスト = TDaiyoZyomuinUriageListGetRes &
  Partial<{
    行ID: symbol
    表示_日当: number
    表示_酸素単価: number
    表示_窒素単価: number
    表示_アルゴン単価: number
    表示_距離単価: number
  }>
//#endregion

/**
 * 太陽 乗務員売上入力
 * @returns
 */
const DaiyoZyomuinUriageRegister = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "DaiyoZyomuinUriageRegister_GridId"

  //#region [method]

  interface ICalculatedFields {
    固定費_固定費: number
    酸素_変動費: number
    窒素_変動費: number
    アルゴン_変動費: number
    距離変動費_変動費: number
    出勤日数: number
    // 乗務員売上額: number
    表示_日当: number
    表示_酸素単価: number
    表示_窒素単価: number
    表示_アルゴン単価: number
    表示_距離単価: number
    sum乗務員売上額: number
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T大陽乗務員売上リスト>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        // 表示用の単価を設定
        // KAIROS-1088: マスタ更新後も過去保存値で計算するため、売上保存値を優先する
        表示_酸素単価: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          return i.大陽乗務員売上_酸素単価 ?? i.酸素単価
        },
        表示_窒素単価: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          return i.大陽乗務員売上_窒素単価 ?? i.窒素単価
        },
        表示_アルゴン単価: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          return i.大陽乗務員売上_アルゴン単価 ?? i.アルゴン単価
        },
        表示_距離単価: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          return i.大陽乗務員売上_距離単価 ?? i.距離単価
        },
        // KAIROS-1088: 日当も売上保存値を優先（マスタ更新が過去計算に影響しないように）
        // 既存レコード（大陽乗務員売上IDあり）はマスタへフォールバックしない（D1）
        // 新規レコード（大陽乗務員売上IDなし）のみマスタを参照
        表示_日当: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          if (i.大陽乗務員売上ID) {
            return i.大陽乗務員売上_日当 ?? 0
          }
          return i.日当 ?? 0
        },

        // 費用計算
        固定費_固定費: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const 日当 = new Decimal(i.表示_日当 ?? 0)
          const 出勤日数 = new Decimal(i.出勤日数 ?? 0)

          return 日当.times(出勤日数).round().toNumber()
        },
        酸素_変動費: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const 酸素数量 = new Decimal(i.酸素数量 ?? 0)
          const 表示_酸素単価 = new Decimal(i.表示_酸素単価 ?? 0)

          return 酸素数量.times(表示_酸素単価).round().toNumber()
        },
        窒素_変動費: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const 窒素数量 = new Decimal(i.窒素数量 ?? 0)
          const 表示_窒素単価 = new Decimal(i.表示_窒素単価 ?? 0)

          return 窒素数量.times(表示_窒素単価).round().toNumber()
        },
        アルゴン_変動費: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const アルゴン数量 = new Decimal(i.アルゴン数量 ?? 0)
          const 表示_アルゴン単価 = new Decimal(i.表示_アルゴン単価 ?? 0)

          return アルゴン数量.times(表示_アルゴン単価).round().toNumber()
        },
        距離変動費_変動費: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const 距離 = new Decimal(i.距離 ?? 0)
          const 表示_距離単価 = new Decimal(i.表示_距離単価 ?? 0)

          return 距離.times(表示_距離単価).round().toNumber()
        },
        sum乗務員売上額: (i: T大陽乗務員売上リスト & ICalculatedFields) => {
          Decimal.set({ rounding: 4 })
          const 固定費_固定費 = new Decimal(i.固定費_固定費 ?? 0)
          const 酸素_変動費 = new Decimal(i.酸素_変動費 ?? 0)
          const 窒素_変動費 = new Decimal(i.窒素_変動費 ?? 0)
          const アルゴン_変動費 = new Decimal(i.アルゴン_変動費 ?? 0)
          const 距離変動費_変動費 = new Decimal(i.距離変動費_変動費 ?? 0)

          // 四捨五入して整数とする
          return 固定費_固定費
            .plus(酸素_変動費)
            .plus(窒素_変動費)
            .plus(アルゴン_変動費)
            .plus(距離変動費_変動費)
            .round()
            .toNumber()
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TDaiyoZyomuinUriageListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TDaiyoZyomuinUriageListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new DaiyoZyomuinUriageService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      // setAccordionController(false)
    } catch (error) {
      disPatch(setAlerts(error))
      // disPatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TDaiyoZyomuinUriageListGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TDaiyoZyomuinUriageListGetReq => {
    return {
      年月: 年月 ?? new Date().toISOString(),
      荷主コード,
      荷主名,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TDaiyoZyomuinUriageListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")

    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      荷主CD: 荷主コード,
      荷主名: 荷主名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    disPatch(clearAlert())
  }

  const clearSearchState = () => {
    set年月(eigyobi)
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)
    columnHeaders.columns.forEach((c, index) => {
      c.align = "right"
      // 固定部分
      if (
        c.binding === "表示_日当" ||
        c.binding === "出勤日数" ||
        c.binding === "固定費_固定費"
      ) {
        columnHeaders.setCellData(0, index, "固定費")
      } else if (c.binding?.includes("酸素")) {
        columnHeaders.setCellData(0, index, "酸素")
      } else if (c.binding?.includes("窒素")) {
        columnHeaders.setCellData(0, index, "窒素")
      } else if (c.binding?.includes("アルゴン")) {
        columnHeaders.setCellData(0, index, "アルゴン")
      } else if (
        c.binding === "表示_距離単価" ||
        c.binding === "距離" ||
        c.binding === "距離変動費_変動費"
      ) {
        columnHeaders.setCellData(0, index, "距離変動費")
      } else if (c.binding === "高速料") {
        columnHeaders.setCellData(0, index, "高速料")
        c.align = "right"
      } else if (c.binding === "sum乗務員売上額") {
        columnHeaders.setCellData(0, index, "乗務員売上額")
        c.align = "right"
      } else {
        const setHeaderText = c.header ?? ""
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
      c.allowMerging = true
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
        cell.style.textAlign = "center"
      }
    }

    // ヘッダの設定
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      // const cellBinding = e.getColumn().binding
      // if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      //   //削除済フラグの行はreadonly
      //   if (e.getRow().dataItem.削除フラグ) {
      //     wjCore.toggleClass(e.cell, "read-only-cell", true)
      //     return
      //   }
      // }
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TDaiyoZyomuinUriagePutReq> = []

      gridData.data.sourceCollection.forEach(
        (d: T大陽乗務員売上リスト & ICalculatedFields) => {
          // データEntityを更新用リストに詰めていく
          let data: TDaiyoZyomuinUriagePutReq = {
            大陽乗務員売上ID: d.大陽乗務員売上ID,
            年月: dateUtil.format(年月!, "YYYY/MM/01"),
            大陽乗務員単価ID: d.大陽乗務員単価ID,
            出勤日数: d.出勤日数,
            日当: d.表示_日当,
            固定費: d.固定費_固定費,
            酸素単価: d.表示_酸素単価,
            酸素数量: d.酸素数量 ?? undefined,
            酸素変動費: d.酸素_変動費,
            窒素単価: d.表示_窒素単価,
            窒素数量: d.窒素数量 ?? undefined,
            窒素変動費: d.窒素_変動費,
            アルゴン単価: d.表示_アルゴン単価,
            アルゴン数量: d.アルゴン数量 ?? undefined,
            アルゴン変動費: d.アルゴン_変動費,
            距離単価: d.表示_距離単価,
            距離: d.距離 ?? undefined,
            距離変動費: d.距離変動費_変動費,
            高速料: d.高速料 ?? undefined,
            乗務員売上額: d.sum乗務員売上額,
            更新日時: d.大陽乗務員売上作成_更新日時,
            削除フラグ: 0,
          }
          dataList.push(data)
        }
      )

      const service = new DaiyoZyomuinUriageService()

      let res: TApiResponse<boolean>

      // 受注配車の更新フラグによりAPI変更
      if (isHaisyaUpdate) {
        res = await service.putHaisya(dataList)
      } else {
        res = await service.put(dataList)
      }

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast("売上情報の更新が完了しました。")
      }

      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = queryParse()

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      search(querySearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const initializeComboBox = () => {
    setComboBoxInitialized(true)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // 受注配車の更新フラグ
  const [isHaisyaUpdate, setIsHaisyaUpdate] = useState<boolean>(false)
  //#endregion

  //#region [state]
  // 固定項目

  // state
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [年月, set年月] = useState<string | null>()

  // ComboBox用
  const [comboBoxInitialized, setComboBoxInitialized] = useState<boolean>(false)

  // modal
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `大陽 乗務員売上入力`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
    set年月(eigyobi)
    initializeComboBox()
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboBoxInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboBoxInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">大陽 乗務員売上入力</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <MonthInput
                              id="年月"
                              autoFocus
                              value={年月}
                              setValue={set年月}
                              isRequired
                              placeholder="年月"
                            />
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                placeholder="荷主CD"
                                value={荷主コード}
                                maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                                setValue={(v) => {
                                  set荷主コード(v)
                                }}></TextInput>
                              <button
                                type="button"
                                className="icon-button"
                                onClick={() => {
                                  setIs荷主検索Modal(true)
                                }}>
                                <FontAwesomeIcon
                                  className="icon-button-inner"
                                  icon={faSearch}
                                />
                              </button>
                              <TextInput
                                style={{ width: "20rem" }}
                                id="荷主名"
                                name="荷主名"
                                placeholder="荷主名"
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                                value={荷主名}
                                setValue={(v) => {
                                  set荷主名(v)
                                }}></TextInput>
                            </div>
                            <Button
                              type="submit"
                              className="ms-auto"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                isEnablePageSize={"hidden"}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                hasFilter={false}
                gridProperties={{
                  isReadOnly: false,
                  allowDragging: wjcGrid.AllowDragging.None,
                  keyActionTab: wjcGrid.KeyAction.CycleOut,
                  frozenColumns: 5,
                }}
                headerComponent={
                  // <div className="d-flex">
                  <>
                    <Button
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setIsHaisyaUpdate(false)
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                    {/* 受注配車更新（KAIROS-1088: 加算ロジックの二度押しインフレ防止ガード G1+G2） */}
                    <Button
                      disabled={
                        isSearching ||
                        // G1: 検索結果が空でない かつ 全行が受注配車反映済 の場合は disable
                        ((gridData?.data?.sourceCollection?.length ?? 0) > 0 &&
                          gridData.data.sourceCollection.every(
                            (d: T大陽乗務員売上リスト) =>
                              !!d.受注配車反映処理日時
                          ))
                      }
                      style={{ marginLeft: "10rem" }}
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        // G2: 反映済行が一部でも含まれる場合は確認ダイアログ
                        const has反映済 =
                          gridData?.data?.sourceCollection?.some(
                            (d: T大陽乗務員売上リスト) =>
                              !!d.受注配車反映処理日時
                          ) ?? false
                        if (has反映済) {
                          if (
                            !window.confirm(
                              "受注配車反映処理日時が入っている行が含まれます。\n" +
                                "再度更新すると 受注配車側の乗務員売上額に加算 されます。\n" +
                                "続行しますか？"
                            )
                          ) {
                            return
                          }
                        }
                        setIsHaisyaUpdate(true)
                        beforeSubmit()
                      }}>
                      受注配車更新
                    </Button>
                    {/* TODO:何かのアクションボタン？ */}
                    <Button
                      disabled={isSearching}
                      className="btn-secondary"
                      onClick={() => {}}>
                      光英車輌集計表データから距離・高速料取得
                    </Button>
                  </>
                  // </div>
                }>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="荷主略称1"
                  width={160}
                  header="荷主">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<
                        T大陽乗務員売上リスト & ICalculatedFields
                      >
                    ) => {
                      return `${context.item.荷主コード}:${context.item.荷主略称1}`
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表紙分割コード"
                  width={140}
                  header="荷主請求">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<
                        T大陽乗務員売上リスト & ICalculatedFields
                      >
                    ) => {
                      if ((context.item.荷主請求ID ?? 0) === 0) return
                      return `${context.item.表紙分割コード}:${context.item.表紙名}`
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="品名"
                  width={100}
                  header="品名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="車番"
                  width={60}
                  header="車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="社員氏名"
                  width={120}
                  header="乗務員"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表示_日当"
                  width={70}
                  header="日当"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="出勤日数"
                  format="N2"
                  width={80}
                  header="出勤日数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="固定費_固定費"
                  width={100}
                  header="固定費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表示_酸素単価"
                  width={70}
                  header="単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="酸素数量"
                  width={70}
                  format="N3"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N3",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="酸素_変動費"
                  width={100}
                  header="酸素変動費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表示_窒素単価"
                  width={70}
                  header="単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="窒素数量"
                  width={70}
                  format="N3"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N3",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="窒素_変動費"
                  width={100}
                  header="窒素変動費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表示_アルゴン単価"
                  width={70}
                  header="単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="アルゴン数量"
                  width={70}
                  format="N3"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N3",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="アルゴン_変動費"
                  width={110}
                  header="アルゴン変動費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="表示_距離単価"
                  width={70}
                  header="単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="距離"
                  width={70}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="距離"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="距離変動費_変動費"
                  width={100}
                  header="距離変動費"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="高速料"
                  width={100}
                  format="N0"
                  editor={
                    new wjcInput.InputNumber(document.createElement("div"), {
                      format: "N0",
                      min: 0,
                      isRequired: false,
                    })
                  }
                  header="高速料"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="sum乗務員売上額"
                  width={100}
                  header="乗務員売上額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  isReadOnly
                  cssClass="read-only-cell"
                  binding="受注配車反映処理日時"
                  width={140}
                  header="受注配車更新日時">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<
                        T大陽乗務員売上リスト & ICalculatedFields
                      >
                    ) => {
                      if (
                        stringUtil.isNullOrWhiteSpace(
                          context.item.受注配車反映処理日時
                        )
                      )
                        return ""
                      return dateUtil.format(
                        context.item.受注配車反映処理日時,
                        "YYYY/MM/DD HH:mm"
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        <p>入力された内容で更新しますか？</p>
        {isHaisyaUpdate && (
          <p>
            ※退職者など、更新対象の受注配車が存在しなかったデータに関しては受注配車更新日時の更新を行いません
          </p>
        )}
      </ConfirmModal>
    </Container>
  )
}

export default DaiyoZyomuinUriageRegister
